import { ContextQuestionModel } from './context-questions-model';

export interface QuestionGroupModel {
  questionId: string;
  index: number;
  text: string;
  isAnswered: boolean;
  questions: ContextQuestionModel[];
}
